import * as React from 'react';
import './styles.css';
import { inject, observer } from 'mobx-react';
import { InlineDatePicker, MuiPickersUtilsProvider } from 'material-ui-pickers';
import LuxonUtils from '@date-io/luxon';
import { DateTime } from 'luxon';
import { WithStyles, withStyles, FormGroup, FormControlLabel, Checkbox, TextField, createStyles, Theme } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import { UiStore } from '../../stores/ui-store';
import { SalesStore } from '../../stores/sales-store';
import { dateFormatted } from '../../datetime';
import { globalStyles } from '../../theme';

export interface IDemurrageChargeTabProps extends WithStyles<typeof styles> {
    salesStore?: SalesStore
    uiStore?: UiStore
}

@inject('uiStore', 'salesStore')
@observer
class DemurrageChargeTab extends React.Component<IDemurrageChargeTabProps, {}> {

    public render() {
        const { salesStore } = this.props;
        const { orderUiState } = this.props.uiStore!;
        const delivery = salesStore!.order.delivery;

        return (
            <div className="freight">
                <FormGroup row>
                    <MuiPickersUtilsProvider utils={LuxonUtils}>
                        <InlineDatePicker
                            onlyCalendar
                            className={this.props.classes.inlineDateField}
                            label={delivery.dateTba ? "Date is TBA" : "Date"}
                            clearable
                            value={delivery.date}
                            onChange={(date: DateTime) => delivery.updateAndValidate('date', date.startOf('day'))}
                            labelFunc={(date: DateTime) => dateFormatted(date)}
                            InputProps={{ disableUnderline: true }}
                            leftArrowIcon={<KeyboardArrowLeft />}
                            rightArrowIcon={<KeyboardArrowRight />}
                            error={!!delivery.errors.date}
                            helperText={delivery.errors.date || null}
                            maxDate={DateTime.local().plus({ months: 6 })}
                            minDate={DateTime.local().minus({ days: 1 })}
                            disabled={delivery.dateTba || orderUiState.isReadonly('deliveryDate')}
                        />
                    </MuiPickersUtilsProvider>
                    <FormControlLabel
                        className={this.props.classes.checkBox}
                        control={
                            <Checkbox
                                checked={delivery.dateTba}
                                onChange={(_e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => delivery.updateDateTba(checked)}
                                disabled={orderUiState.isReadonly('deliveryDate')}
                            />
                        }
                        label="TBA"
                    />
                </FormGroup>
                <TextField
                    className={this.props.classes.textFieldFullWidth}
                    InputProps={{ disableUnderline: true }}
                    inputProps={{ maxLength: 200 }}
                    label='Special Instructions'
                    type='text'
                    name='deliveryInstruction'
                    autoComplete='no'
                    value={delivery.instruction}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => delivery.updateAndValidate('instruction', e.currentTarget.value)}
                    disabled={orderUiState.isReadonly('deliveryInstruction')}
                    fullWidth
                    multiline/>
            </div>
        );
    }
}

const styles = (theme: Theme) => createStyles({
    ...globalStyles,
    checkBox: {
        marginTop: -14,
        marginRight: 0,
    },
    checkBoxLabel: {
        fontSize: "1rem",
        color: theme.palette.text.secondary
    }
});

export default withStyles(styles)(DemurrageChargeTab);
